import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { Button, Text, useTheme } from '@rneui/themed';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@rneui/themed';

const DeleteAccountButton = ({ deleteUserAndLogout }) => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const [infoVisible, setInfoVisible] = useState(false);
  const [logoutVisible, setLogoutVisible] = useState(false);

  const doDeleteUserAndLogout = async () => {
    try {
      await deleteUserAndLogout();
    } catch (error) {
      setLogoutVisible(true);
    }
    setInfoVisible(false);
  };

  return (
    <>
      <Button
        style={{ marginTop: 30 }}
        buttonStyle={{ backgroundColor: theme.colors.secondary }}
        title={t('personal.deleteAccount')}
        onPress={() => setInfoVisible(true)}
      />
      <Dialog
        overlayStyle={styles.overlayStyle}
        isVisible={infoVisible}
        onBackdropPress={() => setInfoVisible(false)}
      >
        <Dialog.Title title={t('personal.deleteAccount')} />
        <Text>{t('personal.deleteAccountText')}</Text>
        <Dialog.Actions>
          <Dialog.Button
            buttonStyle={{ backgroundColor: theme.colors.secondary }}
            title={t('personal.deleteAccount')}
            type="solid"
            onPress={doDeleteUserAndLogout}
          />
          <Dialog.Button
            title={t('cancel')}
            type="outline"
            onPress={() => setInfoVisible(false)}
          />
        </Dialog.Actions>
      </Dialog>
      <Dialog
        overlayStyle={styles.overlayStyle}
        isVisible={logoutVisible}
        onBackdropPress={() => setLogoutVisible(false)}
      >
        <Dialog.Title title={t('personal.logout')} />
        <Text>{t('personal.logoutNeededText')}</Text>
        <Dialog.Actions>
          <Dialog.Button
            title={t('cancel')}
            type="outline"
            onPress={() => setLogoutVisible(false)}
          />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

const styles = StyleSheet.create({
  overlayStyle: {
    backgroundColor: 'white',
  },
});

export default DeleteAccountButton;
